import {
  clearAccessToken,
  clearRefreshToken,
  saveAccessToken,
  saveRefreshToken,
} from "../../../api/apiClient";
import { appConst } from "../../../AppConst";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { ILoginVNPTRespone } from "../../../model/respone/auth/ILoginVNPTRespone";
import { eAuthActionTypeDefine } from "../../action-types/auth/IAuthActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const authAction = {
  ...generateActions(eAuthActionTypeDefine, "AUTH"),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGIN_SUCCESS",
    (payload: ILoginRespone) => {
      saveAccessToken(payload.token_info.access_token);
      saveRefreshToken(payload.token_info.refresh_token);
    }
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGOUT_START",
    (payload: any) => {
      if (appConst.OIDC_UNIT === "vnpt") {
        const token = localStorage.getItem("access_token");
        const state = sessionStorage.getItem("oauth_state");
        const logoutUrl = new URL(`${appConst.OIDC_LOGOUT}`);
        if (token) {
          logoutUrl.searchParams.append("id_token_hint", token);
        }
        if (appConst.OIDC_REDIRECT_URI) {
          logoutUrl.searchParams.append(
            "post_logout_redirect_uri",
            appConst.OIDC_REDIRECT_URI
          );
        }
        if (state) {
          logoutUrl.searchParams.append("state", state);
        }
        clearAccessToken();
        clearRefreshToken();
        window.location.href = logoutUrl.toString();
      } else {
        clearAccessToken();
        clearRefreshToken();
      }
    }
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGIN_VNPT_SUCCESS",
    (payload: ILoginVNPTRespone) => {
      saveAccessToken(payload.token_info.access_token);
      saveRefreshToken(payload.token_info.refresh_token);
    }
  ),
};
